/*eslint-disable */
import {bus} from '@/main'; 
import toast from '@/services/toast'; 
export default {
  name: 'complete-demo-req-popup',
  components: {},
  props: ['demoReqID'],
  data () {
    return {
      comment:'',
      submitted:false
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    closeDemoRequestInfoPopup() {
      bus.$emit('completeReqDemoPopupStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
    demoForRequestSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            id:this.demoReqID,
            is_completed:true,
            comment:this.comment,
          }
          this.$store.dispatch('updateDemoReqInfoAction', data)
            .then((res) => {  
              this.closeDemoRequestInfoPopup();
              this.$store.dispatch('getAllDemoRequestListAction')
              toast.success(res.data.msg || 'Request processed successfully.');
              this.submitted =  false;
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
  }
}